import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

import Button from '../../common/Button';

import styles from './upload-file-components.module.scss';

export function UploadFileForm({ selectedFile, handleFileSelect }) {
  return (
    <div className={styles.uploadArea}>
      <div className={styles.uploadBox}>
        <div className={styles.uploadLabel}>
          <div className={styles.uploadIcon}>
            <FontAwesomeIcon icon={faFileUpload} />
          </div>
          <span>{selectedFile?.name || 'Select a file to upload'}</span>
        </div>

        <div className={styles.browseButton}>
          <input type="file" accept=".csv" onChange={handleFileSelect} className={styles.fileInput} id="fileInput" />
          <Button text="Browse files" color="white" shouldUseModernStyles={true} />
        </div>
      </div>
    </div>
  );
}

UploadFileForm.propTypes = {
  handleFileSelect: PropTypes.func.isRequired,
  selectedFile: PropTypes.object,
};
